import * as libphonenumber from 'libphonenumber-js';

const CALLING_CODE_GROUPS = [
    { code: '41', groups: [2, 3, 2, 2] },
    { code: '33', groups: [1, 2, 2, 2, 2] },
    { code: '49', groups: [3, 3, 3] },
    { code: '39', groups: [3, 3, 3] },
];

function libraryParser() {
    const exported = libphonenumber.parsePhoneNumberFromString
        || libphonenumber.parsePhoneNumber
        || libphonenumber.default;
    const parser = typeof exported === 'function' ? exported : exported?.default;
    return typeof parser === 'function' ? parser : null;
}

function internationalCandidate(raw) {
    const compact = String(raw || '').trim().replace(/[^\d+]/g, '').replace(/^00/, '+');
    if (!compact)
        return '';
    if (compact.startsWith('+') || compact.startsWith('0'))
        return compact;
    return `+${compact}`;
}

function presentationFromKnownCallingCode(candidate) {
    const digits = candidate.replace(/\D/g, '');
    for (const { code, groups } of CALLING_CODE_GROUPS) {
        if (!digits.startsWith(code))
            continue;
        let national = digits.slice(code.length);
        if (national.startsWith('0'))
            national = national.slice(1);
        const expected = groups.reduce((sum, size) => sum + size, 0);
        if (national.length !== expected)
            continue;
        const parts = [];
        let rest = national;
        for (const size of groups) {
            parts.push(rest.slice(0, size));
            rest = rest.slice(size);
        }
        return {
            display: `+${code} ${parts.join(' ')}`,
            uri: `tel:+${code}${national}`,
        };
    }
    return null;
}

/**
 * Display + tel URI for a raw stored phone (digits with country code, 00…, or +…).
 * @returns {{ display: string, uri: string } | null}
 */
export function phonePresentation(raw) {
    const value = String(raw ?? '').trim();
    if (!value)
        return null;

    const candidate = internationalCandidate(value);
    const parser = libraryParser();
    const parsed = parser && candidate ? parser(candidate) : undefined;
    if (parsed?.isValid?.()) {
        return {
            display: parsed.formatInternational(),
            uri: parsed.getURI(),
        };
    }

    const known = candidate ? presentationFromKnownCallingCode(candidate) : null;
    if (known)
        return known;

    const digits = value.replace(/[^\d+]/g, '');
    return {
        display: value,
        uri: `tel:${digits || value}`,
    };
}
